import React from "react";
import { Spinner } from "reactstrap";

const Spinners = () => {
    return (
        <React.Fragment>
            <Spinner
                color="primary"
                className="position-absolute top-50 start-50"
                style={{
                    animationDuration: '1.5s' // Slow down the spinner animation
                }}
            />
        </React.Fragment>
    );
}

export default Spinners;
